// extracted by mini-css-extract-plugin
export default {"progress":"Lightbox_progress__BTiPu"};